module.exports = __webpack_public_path__ + "assets/img/5-1.0014a19d.svg";